// extracted by mini-css-extract-plugin
export default {"header":"HeaderContinent_header__BQEFQ","image":"HeaderContinent_image__Kt-LJ","breaker":"HeaderContinent_breaker__WusZ8"};